export const EmotionScores = [0, 1, 2, 3, 4] as const;

export type EmotionScore = (typeof EmotionScores)[number];

export type EmotionStyle = 'default' | 'emoji' | 'star' | 'smiley';

const LEGACY_COLORS = {
  tangerine: '#F39C11',
  crimson: '#EA4031',
  black_500: '#929292',
  kelly: '#07875A',
  kelly_dark: '#067951',
};

export const EMOTION_COLORS = [
  LEGACY_COLORS.crimson,
  LEGACY_COLORS.tangerine,
  LEGACY_COLORS.black_500,
  LEGACY_COLORS.kelly,
  LEGACY_COLORS.kelly_dark,
];
